/* eslint no-console: off */
 import React from 'react';
import './styles.scss';
import { DataQuery, TimeLine, VisualizationTypes } from 'app/entities/dashboard/utils/utils';
import { TimeRange } from 'app/entities/dashboard/timeRange';
import { FluxChart } from './chart';
import { BigNumber } from './bigNumber';

export type ChartProps = {
  style?: React.CSSProperties;
  updateOnce?: boolean;
  height?: number;
  width?: number;
  margin?: number;
  type?: VisualizationTypes;
  data?: TimeLine[];
  dataQuery?: DataQuery;
  timeRange?: TimeRange;
  widgetOption?: string;
  colorScheme?: string | null;
  theme?: string;
  preview?: boolean
};

const Charts = (props: ChartProps) => {
  const { type, colorScheme, updateOnce = true, theme } = props;

  const timeRange = props?.timeRange ? props?.timeRange : '-1h';
  switch (type) {
    default:
      return (
        <FluxChart
          updateOnce={updateOnce}
          type={type}
          colorScheme={colorScheme}
          dataQuery={props?.dataQuery}
          timeRange={timeRange}
          {...props}
        />
      );
  }
};

export default Charts;

export const CustomTooltip = props => {
  if (props.active && props.payload && props.payload.length) {
    const specs = props.payload[0].payload;
    return (
      <div className="custom-tooltip">
        {Object.keys(specs).map(function (key, index) {
          return (
            <div key={index} className="customPair">
              <div className="field" key={index}>
                {key}:&nbsp;
              </div>
              <div className="value" key={index}>
                {specs[key]}
              </div>
            </div>
          );
        })}
      </div>
    );
  } else {
    return null;
  }
};
